import React, { useState, useEffect } from 'react';
import instance from '../../../config/axiosInstance';
import { formatISO, getDay, parseISO } from 'date-fns';
import { FormatColorReset } from '@material-ui/icons';
import { useHistory } from 'react-router-dom';
import ModelsSchedule from './ModelSchedule';
import { Typography } from '@material-ui/core'

const EmployeeData = () => {
    useEffect(() => {
        try {
            const fetchData = async () => {
                try {
                    setLoadingEmployee(true)
                    if (employeeData.length == 0) {
                        await getListEmployees();
                    }
                    if (departmentList.length == 0) {
                        await getListDepartment();
                    }
                    if (disabledEmployee.length == 0) {
                        await getDisabledEmployees();
                    }
                    if (schedule.length == 0) {
                        await getListSchedule();
                    }
                    if (officeList.length == 0) {
                        await getListOffice();
                    }
                    if (locations.length == 0) {
                        await getLocations();
                    }
                    setLoadingEmployee(false)
                } catch (error) {
                    setLoadingEmployee(false)
                    console.log('error' + error)
                }
            };

            fetchData();


        } catch (error) {
            setLoadingEmployee(false)
            console.log('error' + error)
        }

    }, []);

    const params = new URLSearchParams(window.location.search);

    // Pega o valor do parâmetro 'type'
    const type = params.get('type');

    //variáveis 

    const jwt = require('jsonwebtoken');
    const decodedToken = jwt.decode(localStorage.token);
    const [loadingEmployee, setLoadingEmployee] = useState(false);
    const [employeeData, setEmployeeData] = useState([]);
    const [locations, setLocations] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState(null)
    const [selectedBloqueDevice, setSelectedBloquedDevice] = useState(null)
    const [listBlockedDevice, setListBloquedDevice] = useState([
        { value: 'MOBILE_ONLY', displayValue: 'APENAS APLICATIVO' },
        { value: 'WEB_ONLY', displayValue: 'APENAS PONTO-WEB' }
    ])
    const [locationName, setLocationName] = useState([]);
    const [departmentList, setDepartmentList] = useState([]);
    const [officeList, setOfficeList] = useState([]);
    const [disabledEmployee, setDisabledEmployee] = useState([]);
    const employeeNewData = [...employeeData, ...disabledEmployee];
    const [companyName, setCompanyName] = useState(localStorage.getItem('userName'))
    const [selectedDepartment, setSelectedDepartment] = useState('departamento')
    const [employeeFilterSelected, setEmployeeFilterSelected] = useState([])
    const [schedule, setSchedule] = useState([])
    const [dataWorkingDay, setDataWorkingDay] = useState([])
    const [scheduleSelected, setScheduleSelected] = useState('escala')
    const [isFilter, setIsFilter] = useState(false)
    const [status, setStatus] = useState('status')
    const [selectedEmployee, setSelectedEmployee] = useState('')
    const manager = employeeData.filter(employee => employee.isManager == true)
    const employee = (isFilter ? employeeFilterSelected : employeeNewData).sort((a, b) => a.name.localeCompare(b.name));
    const [selected, setSelected] = useState([])
    const [page, setPage] = useState(0); // para rastrear a página atual
    const [rowsPerPage, setRowsPerPage] = useState(5); // número de linhas por página
    const numSelected = selected.length;
    const rowCount = employee.length;
    const [openModalInformation, setOpenModalInformation] = useState(false);
    const [informationEmployee, setInformationEmployee] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorElEmployeeList, setAnchorElEmployeeList] = useState(null);
    const [row, setRow] = useState({})
    const [viewRegistration, setViewRegistration] = useState(type == 'bemvindo' ? true : false)
    const [openDataPerson, setOpenDataPerson] = useState(true)
    const [openOffice, setOpenOffice] = useState(false)
    const [openSchedule, setOpenSchedule] = useState(false)
    const [openBankHours, setOpenBankHours] = useState(false)
    const [openRestrictions, setOpenRestrictions] = useState(false)
    const [isUpdate, setIsUpdate] = useState(false)
    const [dataInformation, setDataInformation] = useState({})
    const [atualizationButton, setAtualizationButton] = useState(false)
    const [office, setOffice] = useState({});
    const [department, setDepartment] = useState({});
    const [optionsCity, setOptionsCity] = useState([]);
    const [employeeId, setEmployeeId] = useState(null)
    const [employeeIds, setEmployeeIds] = useState([])
    const [loading, setLoading] = useState(false)
    const [expanded, setExpanded] = useState({});
    const [openMessage, setOpenMessage] = useState(false)
    const [messageSuccess, setMessageSuccess] = useState('')
    const [openModalOffice, setOpenModalOffice] = useState(office?.id == 'addOffice' || department?.id == 'addDepartment')
    const [demissionDate, setDemissionDate] = useState('')
    const [lastWorkingDay, setLastWorkingDay] = useState('')
    const [confirmDemission, setConfirmDemission] = useState(false)
    const [openModalDemission, setOpenModalDemission] = useState(false)
    const [openModalImport, setOpenModalImport] = useState(false)
    const [openMessageError, setOpenMessageError] = useState(false)
    const [openMessageErrorConfig, setOpenMessageErrorConfig] = useState(false)
    const [messageErrorConfig, setMessageErrorConfig] = useState('')
    const [messageError, setMessageError] = useState('')
    const [disabledBankHours, setDisabledBankHours] = useState(true)
    const [checkedCreatedEmployee, setCheckedCreatedEmployee] = useState(false)
    const [checkedCreatedOffice, setCheckedCreatedOffice] = useState(false)
    const [checkedCreatedSchedule, setCheckedCreatedSchedule] = useState(false)
    const [checkedCreatedBankOfHours, setCheckedCreatedBankOfHours] = useState(false)
    const [checkedCreatedRestrictions, setCheckedCreatedRestrictions] = useState(false)
    const [openModalConfig, setOpenModalConfig] = useState(false)
    const [typeModalConfig, setTypeModalConfig] = useState('')
    const [isAutocompleteVisible, setAutocompleteVisible] = useState(false);
    const [completeEmployee, setCompleteEmployee] = useState(false);
    const [completeOffice, setCompleteOffice] = useState(false);
    const [completeSchedule, setCompleteSchedule] = useState(false);
    const [completeBankOfHours, setCompleteBankOfHours] = useState(false);
    const [completeRestrictions, setCompleteRestrictions] = useState(false);
    const [officeAndDepartmentInfo, setOfficeAndDepartmentInfo] = useState({
        "officeId": null,
        "departmentId": null,
        "admission": '',
        "workplace": {},
        "employeeId": null,
        "pisCode": '',
        "enrollment": null
    })
    const [selectedCity, setSelectedCity] = useState('')
    const [bankOfHoursData, setBankOfHoursData] = useState({
        isBankOfHours: false,
        initialValue: '',
        dtFrom: '',
        dtTo: '',
        extraHoursLimit: false,
        bankHoursEmployeeId: null,
        delete: false
    })
    const [dataCity, setDataCity] = useState([])
    const [createdOffice, setCreatedOffice] = useState({})
    const [initialDateSchedule, setinitialDateSchedule] = useState('')
    const [createdDepartment, setCreatedDepartment] = useState({})
    const [nameNewOffice, setNameNewOffice] = useState('')
    const [nameNewDepartment, setNameNewDepartment] = useState('')
    const [restrictions, setRestrictions] = useState({
        place: false,
        photo: false,
        device: false,
        dtFrom: ''
    })
    const textDataPerson = {
        title: 'Dados pessoais',
        subtitle: 'Preencha as informações pessoais do colaborador'
    }
    const textDataOffice = {
        title: 'Informações do Cargo',
        subtitle: 'Adicione as informações referentes ao contrato do colaborador'
    }
    const textSchedule = {
        title: 'Jornada de Trabalho',
        subtitle: 'Defina a carga horária e o turno de trabalho do colaborador'
    }
    const textBankOfHours = {
        title: 'Banco de horas | Horas Extras',
        subtitle: 'Defina conforme as normas sindicais e politicas da empresa'
    }
    const textRestrictions = {
        title: 'Restrições de Registro de Ponto',
        subtitle: 'Defina as regras e locais onde o colaborador pode registrar seus pontos'
    }

    const message = `Olá!
 
    Temos novidades. Agora, os registros de ponto serão feitos diretamente pelo seu celular. É super fácil e rápido!
    Por favor, baixe o app do Puntu agora mesmo usando os links abaixo:
     
    Download para Android: https://play.google.com/store/apps/details?id=com.cognusgroup.puntu.app
    Download para iPhone: https://apps.apple.com/br/app/puntu/id1365551053?platform=iphone
     
    Caso tenha alguma dúvida de como criar sua conta no aplicativo, assista ao vídeo abaixo:
    https://youtu.be/NnMUCC2GGns
     
    Bom trabalho!`;

    const copyToClipboard = async () => {
        try {
            await navigator.clipboard.writeText(message);
            // usageLog('firtEmployee/CopyText', decodedToken.companyId, decodedToken.id)
            setMessageSuccess('Texto copiado para a área de transferência!')
            setOpenMessage(true)
        } catch (err) {
            console.error('Falha ao copiar texto: ', err);
        }
    };

    //Importar Colaboradores
    const handleImportEmployee = () => {
        setOpenModalImport(true)
    }
    const handleCloseModalImport = () => {
        setOpenModalImport(false)
    }

    const sheetDownload = (url, name) => {
        const link = document.createElement('a');
        link.href = url
        link.download = name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const sendImportEmployee = async (file) => {
        try {
            handleCloseModalImport()
            const fd = new FormData();
            fd.append('file', file);
            const sendImport = await instance.post('/import/employees/xlsx', fd, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            if (sendImport.status == 200) {
                getListEmployees()
                setMessageSuccess('Colaboradores importados com sucesso.')
                setOpenMessage(true)
                window.location.reload(false);
            }
        } catch (error) {
            setOpenMessageErrorConfig(true)
            setMessageErrorConfig(error)
        }
    }



    ///ESCALAS
    const [scheduleNormModel, setScheduleNormModel] = useState({
        scheduleNorm: {
            "workingDay": {
                "description": "Escala Comercial",
                "horaryClosing": "05:30",
                "isRotation": false,
                "isZeroScale": false
            },
            "shifts": [
                {
                    "days": [
                        "SEG",
                        "TER",
                        "QUA",
                        "QUI",
                        "SEX"
                    ],
                    "shiftsTurns": {
                        "firstShiftIni": "08:00",
                        "firstShiftEnd": "12:00",
                        "secondShiftIni": "13:00",
                        "secondShiftEnd": "17:48"
                    },
                    "explicitExpectedWorkInMinutes": null,
                    "considerOnlyWorkingMinutes": false,
                    "clockInNegativeTolerance": null,
                    "clockInPositiveTolerance": null,
                    "clockOutNegativeTolerance": null,
                    "clockOutPositiveTolerance": null,
                    "secondShiftsTolerance": {
                        "clockInNegativeTolerance": null,
                        "clockInPositiveTolerance": null,
                        "clockOutNegativeTolerance": null,
                        "clockOutPositiveTolerance": null
                    },
                    "intervalPositiveTolerance": null,
                    "intervalNegativeTolerance": null,
                    "isToConsiderClockInDelay": false,
                    "flexScaleHours": false,
                    "considerNightHoursCorrectedInBankHour": false,
                    "hasBankHourLimit": false,
                    "specialHoursSundayAndHoliday": false,
                    "maxAccumulatedPositiveTolerance": null,
                    "maxCreditToBankOfHours": null,
                    "specialHoursAfterMinutes": null,
                    "daysOffAndHolidaysFactor": null,
                    "considerRemainingHoursToBankHoursAndExtraHours": false,
                    "holidaysConfig": {
                        "isToFollowNormally": false,
                        "specialExtraHoursInBankHours": false
                    }
                }
            ]
        },
        scheduleNormSab: {
            "workingDay": {
                "description": "Escala Comercial (6x1)",
                "horaryClosing": "05:30",
                "isRotation": false,
                "isZeroScale": false
            },
            "shifts": [
                {
                    "days": [
                        "SEG",
                        "TER",
                        "QUA",
                        "QUI",
                        "SEX"
                    ],
                    "shiftsTurns": {
                        "firstShiftIni": "08:00",
                        "firstShiftEnd": "12:00",
                        "secondShiftIni": "13:00",
                        "secondShiftEnd": "17:48"
                    },
                    "explicitExpectedWorkInMinutes": null,
                    "considerOnlyWorkingMinutes": false,
                    "clockInNegativeTolerance": null,
                    "clockInPositiveTolerance": null,
                    "clockOutNegativeTolerance": null,
                    "clockOutPositiveTolerance": null,
                    "secondShiftsTolerance": {
                        "clockInNegativeTolerance": null,
                        "clockInPositiveTolerance": null,
                        "clockOutNegativeTolerance": null,
                        "clockOutPositiveTolerance": null
                    },
                    "intervalPositiveTolerance": null,
                    "intervalNegativeTolerance": null,
                    "isToConsiderClockInDelay": false,
                    "flexScaleHours": false,
                    "considerNightHoursCorrectedInBankHour": false,
                    "hasBankHourLimit": false,
                    "specialHoursSundayAndHoliday": false,
                    "maxAccumulatedPositiveTolerance": null,
                    "maxCreditToBankOfHours": null,
                    "specialHoursAfterMinutes": null,
                    "daysOffAndHolidaysFactor": null,
                    "considerRemainingHoursToBankHoursAndExtraHours": false,
                    "holidaysConfig": {
                        "isToFollowNormally": false,
                        "specialExtraHoursInBankHours": false
                    }
                },
                {
                    "days": [
                        "SAB"
                    ],
                    "shiftsTurns": {
                        "firstShiftIni": "08:00",
                        "firstShiftEnd": "12:00",
                        "secondShiftIni": null,
                        "secondShiftEnd": null
                    },
                    "explicitExpectedWorkInMinutes": null,
                    "considerOnlyWorkingMinutes": false,
                    "clockInNegativeTolerance": null,
                    "clockInPositiveTolerance": null,
                    "clockOutNegativeTolerance": null,
                    "clockOutPositiveTolerance": null,
                    "secondShiftsTolerance": {
                        "clockInNegativeTolerance": null,
                        "clockInPositiveTolerance": null,
                        "clockOutNegativeTolerance": null,
                        "clockOutPositiveTolerance": null
                    },
                    "intervalPositiveTolerance": null,
                    "intervalNegativeTolerance": null,
                    "isToConsiderClockInDelay": false,
                    "flexScaleHours": false,
                    "considerNightHoursCorrectedInBankHour": false,
                    "hasBankHourLimit": false,
                    "specialHoursSundayAndHoliday": false,
                    "maxAccumulatedPositiveTolerance": null,
                    "maxCreditToBankOfHours": null,
                    "specialHoursAfterMinutes": null,
                    "daysOffAndHolidaysFactor": null,
                    "considerRemainingHoursToBankHoursAndExtraHours": false,
                    "holidaysConfig": {
                        "isToFollowNormally": false,
                        "specialExtraHoursInBankHours": false
                    }
                }
            ]
        },
        rotationsHours: {
            "workingDay": {
                "description": "Escala Padrão 12x36",
                "horaryClosing": "05:30",
                "isRotation": true,
                "isZeroScale": false,
                "category": "HOURS",
                "amountWork": "12",
                "amountLoose": "36"
            },
            "shifts": [
                {
                    "days": [],
                    "shiftsTurns": {
                        "firstShiftIni": "07:00",
                        "firstShiftEnd": "12:00",
                        "secondShiftIni": "13:00",
                        "secondShiftEnd": "19:00"
                    }
                }
            ]
        },
        rotationsDays: {
            "workingDay": {
                "description": "Escala 6x1",
                "horaryClosing": "05:30",
                "isRotation": true,
                "isZeroScale": false,
                "category": "DAYS",
                "amountWork": "6",
                "amountLoose": "1"
            },
            "shifts": [
                {
                    "days": [
                        "SEG",
                        "TER",
                        "QUA",
                        "QUI",
                        "SEX",
                        "SAB"
                    ],
                    "shiftsTurns": {
                        "firstShiftIni": "08:00",
                        "firstShiftEnd": "12:00",
                        "secondShiftIni": "13:00",
                        "secondShiftEnd": "18:00"
                    }
                }
            ]
        },
        flexHours: {
            "workingDay": {
                "description": "Escala Padrão Hora fixa",
                "horaryClosing": "05:30",
                "isRotation": false,
                "isZeroScale": true
            },
            "shifts": [
                {
                    "days": [
                        "SEG",
                        "TER",
                        "QUA",
                        "QUI",
                        "SEX"
                    ],
                    "shiftsTurns": {
                        "firstShiftIni": "08:00",
                        "firstShiftEnd": "00:00",
                        "secondShiftIni": null,
                        "secondShiftEnd": null
                    },
                    "explicitExpectedWorkInMinutes": "08:00",
                    "considerOnlyWorkingMinutes": true,
                    "clockInNegativeTolerance": null,
                    "clockInPositiveTolerance": null,
                    "clockOutNegativeTolerance": null,
                    "clockOutPositiveTolerance": null,
                    "secondShiftsTolerance": {
                        "clockInNegativeTolerance": null,
                        "clockInPositiveTolerance": null,
                        "clockOutNegativeTolerance": null,
                        "clockOutPositiveTolerance": null
                    },
                    "intervalPositiveTolerance": null,
                    "intervalNegativeTolerance": null,
                    "isToConsiderClockInDelay": false,
                    "flexScaleHours": false,
                    "considerNightHoursCorrectedInBankHour": false,
                    "hasBankHourLimit": false,
                    "specialHoursSundayAndHoliday": false,
                    "maxAccumulatedPositiveTolerance": null,
                    "maxCreditToBankOfHours": null,
                    "specialHoursAfterMinutes": null,
                    "daysOffAndHolidaysFactor": null,
                    "considerRemainingHoursToBankHoursAndExtraHours": false,
                    "holidaysConfig": {
                        "isToFollowNormally": false,
                        "specialExtraHoursInBankHours": false
                    }
                }
            ]
        },
        scheduleHours: {
            "workingDay": {
                "description": "Escala Padrão Horista",
                "horaryClosing": "05:30",
                "isRotation": false,
                "isZeroScale": true
            },
            "shifts": [
                {
                    "days": [
                        "SEG",
                        "TER",
                        "QUA",
                        "QUI",
                        "SEX"
                    ],
                    "shiftsTurns": {
                        "firstShiftIni": "00:00",
                        "firstShiftEnd": "00:00",
                        "secondShiftIni": null,
                        "secondShiftEnd": null
                    },
                    "explicitExpectedWorkInMinutes": null,
                    "considerOnlyWorkingMinutes": true,
                    "clockInNegativeTolerance": null,
                    "clockInPositiveTolerance": null,
                    "clockOutNegativeTolerance": null,
                    "clockOutPositiveTolerance": null,
                    "secondShiftsTolerance": {
                        "clockInNegativeTolerance": null,
                        "clockInPositiveTolerance": null,
                        "clockOutNegativeTolerance": null,
                        "clockOutPositiveTolerance": null
                    },
                    "intervalPositiveTolerance": null,
                    "intervalNegativeTolerance": null,
                    "isToConsiderClockInDelay": false,
                    "flexScaleHours": true,
                    "considerNightHoursCorrectedInBankHour": false,
                    "hasBankHourLimit": false,
                    "specialHoursSundayAndHoliday": false,
                    "maxAccumulatedPositiveTolerance": null,
                    "maxCreditToBankOfHours": null,
                    "specialHoursAfterMinutes": null,
                    "daysOffAndHolidaysFactor": null,
                    "considerRemainingHoursToBankHoursAndExtraHours": false,
                    "holidaysConfig": {
                        "isToFollowNormally": false,
                        "specialExtraHoursInBankHours": false
                    }
                }
            ]
        }
    })


    let modelsSchedules = [
        {
            value: 'scheduleNorm', dataSchedule: scheduleNormModel.scheduleNorm, label: 'Escala Comercial (Segunda a Sexta)',
            text: <Typography style={{ color: '#464a53', fontFamily: 'montserrat', fontSize: 12 }}>
                • O colaborador trabalha de segunda a sexta com folga de sábado e domingo <br />
                • A jornada diária geralmente dura 8 horas <br />
                • Segundo a lei, as folgas não precisam ser em dias seguidos
            </Typography>
        },
        {
            value: 'scheduleNormSab', dataSchedule: scheduleNormModel.scheduleNormSab, label: 'Escala Comercial (Segunda a Sábado)',
            text: <Typography style={{ color: '#464a53', fontFamily: 'montserrat', fontSize: 12 }}>
                • Para empresas que adotam uma jornada de 44 horas semanais, com 8 horas diárias de segunda a sexta-feira e 4 horas no sábado.
            </Typography>
        },
        {
            value: 'rotationsHours', dataSchedule: scheduleNormModel.rotationsHours, label: 'Escala 12x36',
            text: <Typography style={{ color: '#464a53', fontFamily: 'montserrat', fontSize: 12 }}>
                • Para empresas que adotam escalas de revezamento, com um dia de trabalho seguido por um dia de folga, ideal para plantonistas.
            </Typography>
        },
        {
            value: 'rotationsDays', dataSchedule: scheduleNormModel.rotationsDays, label: 'Escala 6x1',
            text: <Typography style={{ color: '#464a53', fontFamily: 'montserrat', fontSize: 12 }}>
                • Para empresas que adotam uma jornada de 6 dias de trabalho seguidos por 1 dia de folga.
            </Typography>
        },
        {
            value: 'flexHours', dataSchedule: scheduleNormModel.flexHours, label: 'Escala Flexivel',
            text: <Typography style={{ color: '#464a53', fontFamily: 'montserrat', fontSize: 12 }}>
                • Para colaboradores que não têm horário fixo, mas uma jornada diária fixa a cumprir.
            </Typography>
        },
        {
            value: 'scheduleHours', dataSchedule: scheduleNormModel.scheduleHours, label: 'Escala de Horista',
            text: <Typography style={{ color: '#464a53', fontFamily: 'montserrat', fontSize: 12 }}>
                • Para colaboradores que não têm escala fixa e são pagos por hora trabalhada.
            </Typography>
        },
    ]

    const optionsModel = [
        {
            value: 'model',
            label: 'Modelos Pré-definidos',
        },
        {
            value: 'schedules',
            label: 'Existentes',
        },
        // {
        //     value: 'createdSchedule',
        //     label: 'Criar escala',
        // },
    ];

    const getDays = (click, day, event) => {
        try {
            let mockDays = [
                {
                    day: 'DOM',
                    isWorking: false,
                    value: 'D',
                    firstShiftIni: null,
                    firstShiftEnd: null,
                    secondShiftIni: null,
                    secondShiftEnd: null
                },
                {
                    day: 'SEG',
                    isWorking: false,
                    value: 'S',
                    firstShiftIni: null,
                    firstShiftEnd: null,
                    secondShiftIni: null,
                    secondShiftEnd: null
                },
                {
                    day: 'TER',
                    isWorking: false,
                    value: 'T',
                    firstShiftIni: null,
                    firstShiftEnd: null,
                    secondShiftIni: null,
                    secondShiftEnd: null
                },
                {
                    day: 'QUA',
                    isWorking: false,
                    value: 'Q',
                    firstShiftIni: null,
                    firstShiftEnd: null,
                    secondShiftIni: null,
                    secondShiftEnd: null
                },
                {
                    day: 'QUI',
                    isWorking: false,
                    value: 'Q',
                    firstShiftIni: null,
                    firstShiftEnd: null,
                    secondShiftIni: null,
                    secondShiftEnd: null
                },
                {
                    day: 'SEX',
                    isWorking: false,
                    value: 'S',
                    firstShiftIni: null,
                    firstShiftEnd: null,
                    secondShiftIni: null,
                    secondShiftEnd: null
                },
                {
                    day: 'SAB',
                    isWorking: false,
                    value: 'S',
                    firstShiftIni: null,
                    firstShiftEnd: null,
                    secondShiftIni: null,
                    secondShiftEnd: null
                }
            ];

            scheduleView.find(workingDay => workingDay.value === event).dataSchedule.shifts.forEach(shift => {
                shift.days.forEach(day => {
                    let index = mockDays.findIndex(mockDay => mockDay.day === day);
                    if (index !== -1) {
                        mockDays[index].isWorking = true;
                        mockDays[index].firstShiftIni = shift.shiftsTurns.firstShiftIni
                        mockDays[index].firstShiftEnd = shift.shiftsTurns.firstShiftEnd
                        mockDays[index].secondShiftIni = shift.shiftsTurns.secondShiftIni
                        mockDays[index].secondShiftEnd = shift.shiftsTurns.secondShiftEnd
                    }
                });
            });

            if (click) {
                setDays(prevDays => {
                    let newDays = JSON.parse(JSON.stringify(prevDays));
                    let index = newDays.findIndex(mockDay => mockDay.day === day);
                    if (index !== -1) {
                        newDays[index].isWorking = !newDays[index].isWorking;
                    }
                    if (selectedModelSchedule === 'model') {
                        let updateDataSchedule = JSON.parse(JSON.stringify(scheduleNormModel));
                        let daysOfWeek = [];
                        newDays.forEach(day => {
                            if (day.isWorking) {
                                daysOfWeek.push(day.day);
                            }
                        });
                        // Verificação e inicialização de shifts
                        if (!updateDataSchedule[selectedSchedule].shifts) {
                            updateDataSchedule[selectedSchedule].shifts = [];
                        }
                        if (!updateDataSchedule[selectedSchedule].shifts[0]) {
                            updateDataSchedule[selectedSchedule].shifts[0] = { days: [] };
                        }

                        updateDataSchedule[selectedSchedule].shifts[0].days = daysOfWeek;
                        setScheduleNormModel(updateDataSchedule);
                    } else {
                        setScheduleNew(prevSchedule => {
                            let updateDataSchedule = JSON.parse(JSON.stringify(prevSchedule));
                            let daysOfWeek = [];
                            newDays.forEach(day => {
                                if (day.isWorking) {
                                    daysOfWeek.push(day.day);
                                }
                            });
                            updateDataSchedule.find(workingDay => workingDay.value === selectedSchedule).dataSchedule.shifts[0].days = daysOfWeek;
                            return updateDataSchedule;
                        });
                    }
                    return newDays;
                });
                return;
            }
            setDays(mockDays);


        } catch (error) {
            console.log(error);
        }
    };


    useEffect(() => {
        if (days.length == 0) {
            getDays()
        }
    }, [])

    const [selectedModelSchedule, setSelectedModelSchedule] = useState('model')
    const [selectedSchedule, setSelectedSchedule] = useState('scheduleNorm')
    const [updatedHoursSchedule, setUpdatedHoursSchedule] = useState(false)
    const [scheduleView, setScheduleNew] = useState(modelsSchedules)
    const [days, setDays] = useState([])
    let horary;

    try {
        const workingDay = scheduleView.find(workingDay => workingDay.value == selectedSchedule);
        if (workingDay && workingDay.dataSchedule && workingDay.dataSchedule.shifts && workingDay.dataSchedule.shifts[0] && workingDay.dataSchedule.shifts[0].shiftsTurns) {
            horary = workingDay.dataSchedule.shifts[0].shiftsTurns;
        } else {
            throw new Error("Estrutura de dados inesperada");
        }
    } catch (error) {
        console.error("Erro ao obter o horário:", error.message);
        // Aqui você pode adicionar qualquer lógica adicional de tratamento de erro, como exibir uma mensagem ao usuário
    }
    let workHours = calculateWorkHours(horary);


    function formatShiftTime(shiftTime) {
        try {
            let firstShiftIni = shiftTime.firstShiftIni == null ? '00:00' : shiftTime.firstShiftIni.substring(0, 5);
            let firstShiftEnd = shiftTime.firstShiftEnd == null ? '00:00' : shiftTime.firstShiftEnd.substring(0, 5);
            let secondShiftIni = shiftTime.secondShiftIni == null ? '00:00' : shiftTime.secondShiftIni.substring(0, 5);
            let secondShiftEnd = shiftTime.secondShiftEnd == null ? '00:00' : shiftTime.secondShiftEnd.substring(0, 5);

            let formattedTime = '';

            if (firstShiftIni !== '00:00') {
                formattedTime += firstShiftIni;
            }
            if (firstShiftEnd !== '00:00') {
                formattedTime += (formattedTime ? '-' : '') + firstShiftEnd;
            }
            if ((firstShiftIni !== '00:00' || firstShiftEnd !== '00:00') && (secondShiftIni !== '00:00' || secondShiftEnd !== '00:00')) {
                formattedTime += ' | ';
            }
            if (secondShiftIni !== '00:00') {
                formattedTime += secondShiftIni;
            }
            if (secondShiftEnd !== '00:00') {
                formattedTime += (formattedTime.endsWith(' | ') ? '' : '-') + secondShiftEnd;
            }

            return formattedTime || null;
        } catch (error) {
            console.log(error)
        }
    }

    function groupShiftsByTime(shifts) {
        try {
            let groupedShifts = {};
            let differentShifts = [];

            shifts.forEach(shift => {
                let formattedTime = formatShiftTime(shift);
                if (!groupedShifts[formattedTime]) {
                    groupedShifts[formattedTime] = [];
                }
                groupedShifts[formattedTime].push(shift.day);
            });

            for (let time in groupedShifts) {
                if (groupedShifts[time].length === 1) {
                    if (time !== null) {
                        differentShifts.push(`${groupedShifts[time][0]} (${time})`);
                    }
                    delete groupedShifts[time];
                }
            }

            let sameShifts = Object.keys(groupedShifts).map(time => {
                if (time !== 'null') {
                    return `${groupedShifts[time].join('/')} (${time})`;
                }
                return null;
            }).filter(item => item !== null);
            differentShifts = differentShifts.filter(shift => !shift.includes('null'));
            return {
                sameShifts: sameShifts,
                differentShifts: differentShifts
            }
        } catch (error) {
            console.log(error)
        }
    }


    function calculateWorkHours(shiftData) {
        try {
            if (shiftData) {
                let totalHours = 0;
                const newShiftData = {
                    firstShiftIni: shiftData.firstShiftIni,
                    firstShiftEnd: shiftData.firstShiftEnd,
                    secondShiftIni: shiftData.secondShiftIni,
                    secondShiftEnd: shiftData.secondShiftEnd,
                }
                for (let key in newShiftData) {
                    if (shiftData[key] !== null) {

                        let timeParts = shiftData[key].split(':');
                        let hours = parseInt(timeParts[0]);
                        let minutes = parseInt(timeParts[1]);

                        // Convert to decimal hours
                        let decimalHours = hours + minutes / 60;

                        // If it's an end time, subtract from total; if it's a start time, add to total
                        if (key.includes('End')) {
                            totalHours -= decimalHours;
                        } else {
                            totalHours += decimalHours;
                        }
                    }
                }

                let hours = Math.floor(Math.abs(totalHours));
                let minutes = Math.round((Math.abs(totalHours) - hours) * 60);

                return `${hours}h${minutes}min`;

            }
        } catch (error) {
            console.log(error)
        }
    }

    const handleChangeHorary = (event, type, isFlex, day) => {
        try {

            if (selectedModelSchedule == 'model') {
                let updateDataSchedule = { ...scheduleNormModel }

                if (selectedSchedule == 'rotationsDays' || selectedSchedule == 'rotationsHours') {
                    // updateDataSchedule[selectedSchedule].shifts[0].explicitExpectedWorkInMinutes = isFlex ? event.target.value : null
                    updateDataSchedule[selectedSchedule].shifts[0].shiftsTurns[type] = event.target.value
                } else {
                    const index = updateDataSchedule[selectedSchedule].shifts.findIndex(shift =>
                        shift.days.includes(day.day)
                    );
                    updateDataSchedule[selectedSchedule].shifts[index].explicitExpectedWorkInMinutes = isFlex ? event.target.value : null
                    updateDataSchedule[selectedSchedule].shifts[index].shiftsTurns[type] = event.target.value
                }

                setScheduleNormModel(updateDataSchedule)

                let newDays = days
                const indexDay = newDays.findIndex(newDay => newDay.day == day.day)
                newDays[indexDay][type] = event.target.value


                return setDays(newDays)
            }
            let updateDataSchedule = JSON.parse(JSON.stringify(scheduleView));
            updateDataSchedule.find(workingDay => workingDay.value == selectedSchedule).dataSchedule.shifts[0].shiftsTurns[type] = event.target.value;
            setScheduleNew(updateDataSchedule);

        } catch (error) {
            console.log(error)
        }
    }

    function groupDaysByShifts(daysArray) {
        const groupedShifts = [];

        daysArray.forEach(dayObj => {
            // Verifica se todos os horários estão nulos
            if (dayObj.firstShiftIni === null && dayObj.firstShiftEnd === null &&
                dayObj.secondShiftIni === null && dayObj.secondShiftEnd === null) {
                return; // Ignora este dia
            }

            const shiftKey = JSON.stringify({
                firstShiftIni: dayObj.firstShiftIni,
                firstShiftEnd: dayObj.firstShiftEnd,
                secondShiftIni: dayObj.secondShiftIni,
                secondShiftEnd: dayObj.secondShiftEnd
            });

            let existingShift = groupedShifts.find(groupedShift =>
                JSON.stringify(groupedShift.shiftsTurns) === shiftKey
            );

            if (existingShift) {
                existingShift.days.push(dayObj.day);
            } else {
                groupedShifts.push({
                    days: [dayObj.day],
                    shiftsTurns: {
                        firstShiftIni: dayObj.firstShiftIni,
                        firstShiftEnd: dayObj.firstShiftEnd,
                        secondShiftIni: dayObj.secondShiftIni,
                        secondShiftEnd: dayObj.secondShiftEnd
                    },
                    explicitExpectedWorkInMinutes: null,
                    considerOnlyWorkingMinutes: false,
                    clockInNegativeTolerance: null,
                    clockInPositiveTolerance: null,
                    clockOutNegativeTolerance: null,
                    clockOutPositiveTolerance: null,
                    secondShiftsTolerance: {
                        clockInNegativeTolerance: null,
                        clockInPositiveTolerance: null,
                        clockOutNegativeTolerance: null,
                        clockOutPositiveTolerance: null
                    },
                    intervalPositiveTolerance: null,
                    intervalNegativeTolerance: null,
                    isToConsiderClockInDelay: false,
                    flexScaleHours: false,
                    considerNightHoursCorrectedInBankHour: false,
                    hasBankHourLimit: false,
                    specialHoursSundayAndHoliday: false,
                    maxAccumulatedPositiveTolerance: null,
                    maxCreditToBankOfHours: null,
                    specialHoursAfterMinutes: null,
                    daysOffAndHolidaysFactor: null,
                    considerRemainingHoursToBankHoursAndExtraHours: false,
                    holidaysConfig: {
                        isToFollowNormally: false,
                        specialExtraHoursInBankHours: false
                    }
                });
            }
        });

        let updateDataSchedule = { ...scheduleNormModel }
        updateDataSchedule[selectedSchedule].shifts = groupedShifts


        return setScheduleNormModel(updateDataSchedule)
    }


    const handleClickUpdateSchedule = () => {
        groupDaysByShifts(days)
        setUpdatedHoursSchedule(!updatedHoursSchedule)
    }

    const processworkingDay = () => {
        const newWorkingDays = []

        dataWorkingDay.map(working => {
            let value = {
                value: working.workingDay.description,
                dataSchedule: working,
                label: working.workingDay.description
            }
            newWorkingDays.push(value)
        })
        setSelectedSchedule(newWorkingDays[0].label)
        setScheduleNew(newWorkingDays)
    }


    const handleChangeTypeSchedule = (event) => {
        if (event.target.value == 'model') {
            setSelectedSchedule('scheduleNorm')
            setScheduleNew(modelsSchedules)
            return setSelectedModelSchedule(event.target.value)
        }
        if (event.target.value == 'schedules') {
            processworkingDay()
            setSelectedModelSchedule(event.target.value)
        }
    }

    const handleChangeModelSchedule = (event) => {
        setSelectedSchedule(prevState => {
            return event.target.value
        })
        getDays(null, null, event.target.value)
    }


    //ESCALAS


    const handleExpandClick = (value) => {
        if (value == 'office' && !employeeId) {
            setMessageError('Opa, faltam dados pessoais obrigatórios para continuar!')
            setOpenMessageError(true)
            return;
        }
        if (value == 'schedule' && !officeAndDepartmentInfo.officeId) {
            setMessageError('Opa, faltam dados do cargo obrigatórios para continuar!')
            setOpenMessageError(true)
            return;
        }
        if (value == 'bankOfHours' && !employeeId) {
            setMessageError('Opa, faltam dados sobre a jornada de trabalho obrigatórios para continuar!')
            setOpenMessageError(true)
            return;
        }
        if (value == 'restrictions' && !employeeId) {
            setMessageError('Opa, faltam dados pessoais obrigatórios para continuar!')
            setOpenMessageError(true)
            return;
        }

        setExpanded({ [value]: !expanded[value] });
        handleSummaryDataPerson(value);

        const resetFunctions = {
            dataPerson: setCompleteEmployee,
            office: setCompleteOffice,
            schedule: setCompleteSchedule,
            bankOfHours: setCompleteBankOfHours,
            restrictions: setCompleteRestrictions,
        };

        if (resetFunctions[value]) {
            resetFunctions[value](false)
        }

    };






    const handleCloseModalOffice = () => {
        setOpenModalOffice(false)
        setOffice({})
        setDepartment({})
        if (isUpdate) {
            setOffice({ name: row._office })
            setDepartment({ name: row.department })

        }
    }


    const handleInputChangeCity = async (event, newInputValue) => {
        try {
            const inputValue = newInputValue || `${event.cityEmployeeWorkplace} - ${event.stateEmployeeWorkplace}`;

            // Processa o input para pegar a cidade
            const processedInputCity = inputValue.includes(' - ') ? inputValue.split(' - ')[0] : inputValue;
            const processedInputState = inputValue.includes(' - ') ? inputValue.split(' - ')[1] : inputValue;

            if (processedInputCity) {
                const response = await instance.get(`static/locations/keyWords/${processedInputCity}`);
                const cities = response.data;

                const nameCities = cities.map(city => ({
                    value: `${city.city} - ${city.state}`,
                    name: `${city.city} - ${city.state}`,
                    state: city.state,
                    city: city.city
                }));

                setOptionsCity(nameCities);
                setSelectedCity(inputValue === newInputValue ? newInputValue : `${event.cityEmployeeWorkplace} - ${event.stateEmployeeWorkplace}`);

                if (cities.length > 0) {
                    const selectedCityData = cities.find(city => city.city === processedInputCity && city.state === processedInputState); 
                    setDataCity(selectedCityData);
                }
            } else {
                setOptionsCity([]);
            }
        } catch (error) {
            console.error("Error fetching cities:", error);
        }
    };




    const handleTextFieldClick = () => {
        setAutocompleteVisible(true);
    };


    const restrictionsEmployee = async (row) => {
        if (!row.restrictions) {
            return;
        }
        const restrict = row.restrictions.split(',')
        const sendRestrictions = await instance.get(`/settings/employees/${row.id}`)
        setRestrictions({
            place: sendRestrictions.data.restrictions.restrictByLocation ? true : false,
            photo: sendRestrictions.data.restrictions.hasPhoto ? true : false,
            device: sendRestrictions.data.restrictions.hasRestrictDevice ? true : false,
            dtFrom: sendRestrictions.data.restrictions.dtRef ? sendRestrictions.data.restrictions.dtRef : ''
        })

    }

    function converterMinutos(minutos) {
        let sinal = minutos < 0 ? "-" : "";
        minutos = Math.abs(minutos);
        let horas = Math.floor(minutos / 60);
        let mins = minutos % 60;
        return sinal + horas + ":" + (mins < 10 ? '0' : '') + mins;
    }



    const handleClickMenu = (event, row) => {
        try {
            restrictionsEmployee(row)
            setEmployeeId(row.id)
            getRestrictionsAndLocationEmployee(row.id)
            setAnchorEl(event.currentTarget);
            setRow(row)
            setIsUpdate(true)
            setDataInformation({
                name: row.name ? row.name : '',
                cpf: row.cpf ? row.cpf : '',
                phone: row.phone ? row.phone : '',
                dateOfBird: row.dtBirthday ? row.dtBirthday : '',
                cep: row.cep ? row.cep : '',
                address: row.address ? row.address : ''
            })
            setOffice(officeList.find(office => office.name == row._office))
            setDepartment(departmentList.find(department => department.name == row.department))

            setOfficeAndDepartmentInfo({
                "officeId": officeList.find(office => office.name == row._office)?.id || null,
                "departmentId": departmentList.find(department => department.name == row.department)?.id || null,
                "admission": row.admissionDate ? formatISO(parseISO(row.admissionDate), { representation: 'date' }) : '',
                // "workplace": { "city": "Planaltina", "code": "5217609", "state": "Goiás", "uf": "GO", "priority": 2 },
                "workplace": { "city": row.cityEmployeeWorkplace ? row.cityEmployeeWorkplace : '', "state": row.stateEmployeeWorkplace ? row.stateEmployeeWorkplace : '' },
                "employeeId": employeeId,
                "pisCode": row.pisCode ? row.pisCode : '',
                "enrollment": row.enrollment ? row.enrollment : ''
            })
            setBankOfHoursData({
                isBankOfHours: row.BankHoursEmployee ? true : false,
                initialValue: row.BankHoursEmployee ? converterMinutos(row.BankHoursEmployee.initialValue) : '00:00',
                dtFrom: row.BankHoursEmployee ? row.BankHoursEmployee.dtFrom : '',
                dtTo: row.BankHoursEmployee ? row.BankHoursEmployee.dtTo : '',
                extraHoursLimit: row.BankHoursEmployee ? row.BankHoursEmployee.cumulativeHoursLimit : false,
                bankHoursEmployeeId: row.BankHoursEmployee ? row.BankHoursEmployee.id : null,
                delete: true
            })
            if (row._workingDay) {
                processworkingDay()
            }
            setSelectedModelSchedule(row._workingDay ? 'schedules' : 'model')
            setSelectedSchedule(row._workingDay == '' ? 'scheduleNorm' : row._workingDay)
            handleInputChangeCity(row, null)
            getDays(null, null, selectedSchedule)


        } catch (error) {
            handleMessageError(error)
        }
    };


    const handleChangeBankOfHours = (event, type) => {
        try {
            let updateBankOfHours = { ...bankOfHoursData }
            if (type == 'isBankOfHours' || type == 'extraHoursLimit') {
                setDisabledBankHours(false)
                updateBankOfHours[type] = event.target.checked
                setBankOfHoursData(updateBankOfHours)
                return;
            }
            updateBankOfHours[type] = event.target.value
            setBankOfHoursData(updateBankOfHours)
        } catch (error) {
            handleMessageError(error)
        }

    }

    const handleChangeRestrictions = (event, type) => {
        try {

            if (type == 'dtFrom') {
                let updatedData = { ...restrictions }; // Cria uma cópia do estado atual
                updatedData[type] = event.target.value
                setRestrictions(updatedData);
                return;
            }
            let updatedData = { ...restrictions }; // Cria uma cópia do estado atual
            updatedData[type] = event.target.checked

            setRestrictions(updatedData);
        } catch (error) {
            handleMessageError(error)
        }// Atualiza o estado com os novos dados

    }

    const handleChangeOfficeAndDepartment = (event, type) => {

        try {
            if (type == 'officeId') {
                if (event.target.value == 'Cadastrar um novo cargo') {
                    setOpenModalOffice(true)
                }
                let office = officeList.find(office => office.name == event.target.value)
                setOffice(office);
                let updateOffice = { ...officeAndDepartmentInfo }
                updateOffice[type] = office.id
                setOfficeAndDepartmentInfo(updateOffice)
                return;
            }
            if (type == 'departmentId') {
                if (event.target.value == 'Cadastrar um novo departamento') {
                    setOpenModalOffice(true)
                }
                let department = departmentList.find(department => department.name == event.target.value)
                setDepartment(department);
                let updateDepartment = { ...officeAndDepartmentInfo }
                updateDepartment[type] = department.id
                setOfficeAndDepartmentInfo(updateDepartment)
                return;
            }
            let updatedData = { ...officeAndDepartmentInfo }; // Cria uma cópia do estado atual
            updatedData[type] = event.target.value
            setOfficeAndDepartmentInfo(updatedData)
        } catch (error) {
            handleMessageError(error)
        }
    };


    const handleChangeInformationForm = (event, type) => {
        try {
            setAtualizationButton(true)
            let updatedData = { ...dataInformation }; // Cria uma cópia do estado atual
            updatedData[type] = event.target.value

            setDataInformation(updatedData);
        } catch (error) {
            handleMessageError(error)
        }// Atualiza o estado com os novos dados
    }

    const resetEmployeeForm = () => {
        try {

            if (isUpdate) {
                return setDataInformation({
                    name: row.name ? row.name : '',
                    cpf: row.cpf ? row.cpf : '',
                    phone: row.phone ? row.phone : '',
                    dateOfBird: row.dtBirthday ? row.dtBirthday : '',
                    cep: row.cep ? row.cep : '',
                    address: row.cityEmployeeWorkplace ? row.cityEmployeeWorkplace : ''
                });
            }
            let dataInformationUpdate = {
                name: '',
                cpf: '',
                phone: '',
                dateOfBird: '',
                cep: '',
                address: ''
            }
            setDataInformation(dataInformationUpdate);
        } catch (error) {
            console.log(error)
        }
    }

    const resetOffice = () => {

        if (isUpdate) {
            setOffice(officeList.find(office => office.name == row._office))
            setDepartment(departmentList.find(department => department.name == row.department))
            return setOfficeAndDepartmentInfo({
                "officeId": officeList.find(office => office.name == row._office).id,
                "departmentId": departmentList.find(department => department.name == row.department).id,
                "admission": row.admissionDate ? formatISO(parseISO(row.admissionDate), { representation: 'date' }) : '',
                "workplace": { "city": row.cityEmployeeWorkplace ? row.cityEmployeeWorkplace : '', "state": row.stateEmployeeWorkplace ? row.stateEmployeeWorkplace : '' },
                "employeeId": employeeId,
                "pisCode": row.pisCode ? row.pisCode : '',
                "enrollment": row.enrollment ? row.enrollment : ''
            })
        }

        setOffice({})
        setDepartment({})
        setOfficeAndDepartmentInfo({
            "officeId": '',
            "departmentId": '',
            "admission": '',
            "workplace": {},
            "employeeId": null,
            "pisCode": '',
            "enrollment": ''
        })

    }

    const resetSchedule = () => {
        if (row._workingDay) {
            setSelectedModelSchedule('schedules')
            processworkingDay()
            setSelectedSchedule(row._workingDay)
            return;
        }
        setSelectedModelSchedule('model')
        setSelectedSchedule('scheduleNorm')
        setScheduleNew(modelsSchedules)

    }

    const resetBankOfHours = () => {
        try {
            setBankOfHoursData({
                isBankOfHours: row.BankHoursEmployee ? true : false,
                initialValue: row.BankHoursEmployee ? converterMinutos(row.BankHoursEmployee.initialValue) : '00:00',
                dtFrom: row.BankHoursEmployee ? row.BankHoursEmployee.dtFrom : '',
                dtTo: row.BankHoursEmployee ? row.BankHoursEmployee.dtTo : '',
                extraHoursLimit: row.BankHoursEmployee ? row.BankHoursEmployee.cumulativeHoursLimit : false,
                bankHoursEmployeeId: row.BankHoursEmployee ? row.BankHoursEmployee.id : null,
                delete: true
            })
        } catch (error) {
            console.log(error)
        }
    }

    const resetRestrictions = () => {
        try {
            const restrict = row.restrictions.split(',')
            setRestrictions({
                place: restrict.find(item => item == 'Local') ? true : false,
                photo: restrict.find(item => item == ' Foto') ? true : false,
                device: restrict.find(item => item == ' Dispositivo') ? true : false,
                dtFrom: row.restrictionsDateIni ? row.restrictionsDateIni : ''
            })
        } catch (error) {
            console.log(error)
        }
    }

    const handleClickDiscard = (type) => {
        try {
            setAtualizationButton(false)
            if (type == 'employeeForm') {
                resetEmployeeForm()
            }
            if (type == 'officeForm') {
                resetOffice()
            }
            if (type == 'schedule') {
                resetSchedule()
            }
            if (type == 'bankOfHours') {
                resetBankOfHours()
            }
            if (type == 'restrictions') {
                resetRestrictions()
            }
        } catch (error) {
            console.log(error)
        }
    }
    const handleCloseViewRegistration = () => {
        try {
            let event = {
                target: {
                    value: 'status'
                }
            }
            setEmployeeId(null)
            setOfficeAndDepartmentInfo({
                "officeId": '',
                "departmentId": '',
                "admission": '',
                "workplace": {},
                "employeeId": null,
                "pisCode": '',
                "enrollment": ''
            })
            filterByStatus(event)
            setViewRegistration(false)
            setAnchorEl(null)
            setIsUpdate(false)
            setRow({})
            setDataInformation({
                name: '',
                cpf: '',
                phone: '',
                dateOfBird: '',
                cep: '',
                address: ''
            })
            setOffice({})
            setDepartment({})
            setOpenRestrictions(false)
            setOpenBankHours(false)
            setOpenSchedule(false)
            setOpenOffice(false)
            setOpenDataPerson(true)
            setExpanded(false)
            setLoading(false)
            setBankOfHoursData({
                isBankOfHours: false,
                initialValue: '',
                dtFrom: '',
                dtTo: '',
                extraHoursLimit: false,
                bankHoursEmployeeId: null,
                "delete": false
            })
            setRestrictions({
                place: false,
                photo: false,
                device: false
            })
            setScheduleNew(modelsSchedules)
            setSelectedModelSchedule('model')
            setSelectedSchedule('scheduleNorm')
            setCompleteRestrictions(false)
            setCompleteBankOfHours(false)
            setCompleteSchedule(false)
            setCompleteOffice(false)
            setCompleteEmployee(false)
            setCheckedCreatedEmployee(false)
        } catch (error) {
            console.log(error)
        }

    }

    const handleSummaryDataPerson = (value) => {
        if (value == 'office' && !employeeId) {
            setMessageError('Opa, faltam dados pessoais obrigatórios para continuar!')
            setOpenMessageError(true)
            return;
        }
        if (value == 'schedule' && !officeAndDepartmentInfo.officeId) {
            setMessageError('Opa, faltam dados do cargo obrigatórios para continuar!')
            setOpenMessageError(true)
            return;
        }
        if (value == 'bankOfHours' && !employeeId) {
            setMessageError('Opa, faltam dados pessoais obrigatórios para continuar!')
            setOpenMessageError(true)
            return;
        }
        if (value == 'restrictions' && !employeeId) {
            setMessageError('Opa, faltam dados pessoais obrigatórios para continuar!')
            setOpenMessageError(true)
            return;
        }
        const toggleState = {
            dataPerson: [openDataPerson, setOpenDataPerson],
            office: [openOffice, setOpenOffice],
            schedule: [openSchedule, setOpenSchedule],
            bankOfHours: [openBankHours, setOpenBankHours],
            restrictions: [openRestrictions, setOpenRestrictions]
        };

        if (toggleState[value]) {
            const [state, setState] = toggleState[value];
            setState(!state);
        }
    };



    const handleViewRegistration = () => {
        setViewRegistration(true)
        getDays(null, null, selectedSchedule)
    }

    const handleViewRegistrationReset = () => {
        setEmployeeId(null)
        setViewRegistration(true)
        getDays(null, null, selectedSchedule)
    }

    const saveHeader = (type) => {
        if (type == 'employeeForm') {
            return createdEmployee();
        }
        if (type == 'officeForm') {
            return createdOfficeAndDepartment();
        }
        if (type == 'schedule') {
            return createWorkingDay();
        }
        if (type == 'bankOfHours') {
            return createdAndUpdatedBankOfHours();
        }
        if (type == 'restrictions') {
            return createdAndUpdateRestrictions();
        }
    }

    function timeToMinutes(time) {
        const sign = time.startsWith("-") ? -1 : 1;
        const [hours, minutes] = time.replace("-", "").split(":").map(Number);
        return sign * (hours * 60 + minutes);
    }




    const handleClickDemission = () => {
        setOpenModalDemission(true)
    }

    const handleChangeDemission = (type, event) => {
        if (type == 'demissionDate') {
            return setDemissionDate(event)
        }
        setLastWorkingDay(event)
    }

    const handleInputChangeLocation = (event) => {
        try {
            let locationsSelected = selectedLocation
            const splitLocations = locationsSelected && locationsSelected.indexOf(',') ? locationsSelected.split(',') : null
            const repeatSelected = splitLocations ? splitLocations.includes(event.target.value) : false
            const newLocationsName = locationName.filter(locations => locations.id != 'allLocations')
            setLocationName(newLocationsName)

            if (locationsSelected != null && !repeatSelected) {
                locationsSelected = locationsSelected != event.target.value ? locationsSelected + ',' + event.target.value : locationsSelected
                setLocationName([...locationName, { value: locationsSelected, displayValue: locationsSelected, id: 'allLocations' }])
                return setSelectedLocation(locationsSelected);
            }
            setSelectedLocation(event.target.value)
        } catch (error) {
            console.log(error)
        }
    }

    const handleInputChangeBloquedDevice = (event) => {
        setSelectedBloquedDevice(event.target.value)
    }

    const getRestrictionsAndLocationEmployee = async (employeeId) => {
        try {
            const dt = []
            if (employeeId) {
                const sendRestrictions = await instance.get(`/settings/employees/${employeeId}`)
                sendRestrictions.data.restrictions.listBlockedDevice.map(list => {
                    if (list.value == 'NO_RESTRICTION') {
                        return;
                    }
                    dt.push({ value: list.value, displayValue: list.name })
                })
                setListBloquedDevice(dt)
                setSelectedBloquedDevice(sendRestrictions.data.restrictions.hasBlockedDevice)
                let allowedLocations = JSON.parse(sendRestrictions.data.allowedLocations) || [];
                if (allowedLocations.length > 1) {
                    let descriptionLocation = null
                    allowedLocations.map(location => {
                        if (descriptionLocation == null) {
                            descriptionLocation = location.description
                        } else {
                            descriptionLocation = descriptionLocation + ',' + location.description
                        }
                    })
                    setLocationName([...locationName, { value: descriptionLocation, displayValue: descriptionLocation, id: 'allLocations' }])
                    return setSelectedLocation(descriptionLocation);
                }
                let description = allowedLocations[0]?.description || null;
                setSelectedLocation(description)
                return;
            }
        } catch (error) {
            console.log(error)
        }
    }

    const demissionEmployee = async () => {
        try {
            const dt = {
                "employeeId": employeeId,
                "dtDemission": demissionDate,
                "dtLastDayWork": lastWorkingDay
            }
            const sendDemissionEmployee = await instance.post('/demission/employee', dt, {
                headers: {
                    'Authorization': `Bearer ${decodedToken}`
                }
            })

            if (sendDemissionEmployee.status == 200) {
                getListEmployees()
                getDisabledEmployees()
                setMessageSuccess('Colaborador desligado.')
                setOpenMessage(true)
                setConfirmDemission(false)
                setOpenModalDemission(false)
                setAnchorEl(null)
                window.location.reload(false);
            }
        } catch (error) {
            console.log(error)
            setOpenModalDemission(false)
            setConfirmDemission(false)
            setMessageErrorConfig('O funcionário não pode ser demitido, pois há pontos ativos após o último dia de trabalho.')
            setOpenMessageErrorConfig(true)
        }
    }

    const removeGestor = async () => {
        try {
            const dt = {
                "id": employeeId,
                "isManager": false
            }
            const sendRemoveGestor = await instance.put('/employee', dt, {
                headers: {
                    'Authorization': `Bearer ${decodedToken}`
                }
            })
            if (sendRemoveGestor.status == 200) {
                getListEmployees()
                getDisabledEmployees()
                setMessageSuccess('Gestor removido')
                setOpenMessage(true)
                setConfirmDemission(false)
                setOpenModalDemission(false)
                setAnchorEl(null)
                window.location.reload(false);
            }
        } catch (error) {
            console.log(error)
            handleMessageError(error)
        }

    }


    const reactivateEmployee = async () => {

        try {
            const dt = { "cpfs": [row.cpf] }

            const sendDemissionEmployee = await instance.delete('/employee/reactivateEmployees', { data: { cpfs: [row.cpf] } }, {
                headers: {
                    'Authorization': `Bearer ${decodedToken}`
                }
            })

            if (sendDemissionEmployee.status == 200) {
                getListEmployees()
                getDisabledEmployees()
                setMessageSuccess('Colaborador reativado.')
                setOpenMessage(true)
                setConfirmDemission(false)
                setOpenModalDemission(false)
                setAnchorEl(null)
                window.location.reload(false);
            }

        } catch (error) {
            console.log(error)
            handleMessageError(error)
        }
    }

    function formatDate(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Adiciona zero à esquerda se necessário
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    }


    const createdAndUpdateRestrictions = async () => {
        try {
            if (!employeeId && !openModalConfig) {
                setMessageError('Cadastre os dados pessoais do colaborador para continuar!')
                setOpenMessageError(true)
                return;
            }

            const isAnyRestrictionTrue = restrictions.photo || restrictions.place || restrictions.device;
            if (restrictions.dtFrom === '' && isAnyRestrictionTrue) {
                setMessageError('Defina uma data de início das restrições')
                setOpenMessageError(true)
                return;
            }
            setLoading(true)
            let locationId = []
            let splitLocations = null;
           if (restrictions.place == true) {
            if (selectedLocation) {
                const index = selectedLocation.indexOf(',');
                if (index !== -1) {
                    splitLocations = selectedLocation.split(',');
                } else {
                    console.error('Erro: A localização selecionada não contém uma vírgula.');
                }
            } else {
                 setMessageError('Selecione ao menos uma localização para aplicar as restrições')
                 setOpenMessageError(true);
                 setLoading(false);
                 return
             }
           }
            if (splitLocations && splitLocations.length > 1) {
                splitLocations.map(loc => {
                    const getLocation = locations.find(location => location.description == loc)
                    if (getLocation.description) {
                        locationId.push(getLocation.id)
                    }
                })
            } else {
                locationId = [selectedLocation ? locations.find(location => location.description == selectedLocation).id : null]
            }

            const dt = {
                "employees": openModalConfig ? employeeIds : [employeeId],
                "restrictions": {
                    "dtRef": restrictions.dtFrom == '' ? formatDate(new Date()) : restrictions.dtFrom,
                    "hasPhoto": restrictions.photo,
                    "restrictByLocation": restrictions.place,
                    "hasBlockedDevice": restrictions.device ? selectedBloqueDevice : null
                },
                "allowedLocations": locationId.length > 0 ? locationId : [null]
            }
            const sendCreatedRestrictions = await instance.post('/settings/employees/register/lot', dt, {
                headers: {
                    'Authorization': `Bearer ${decodedToken}`
                }
            })
            if (sendCreatedRestrictions.status == 200) {
                // setEmployeeId(sendCreatedBankOfHours.data.employeeId)
                getListEmployees()
                setLoading(false)
                handleExpandClick('restrictions')
                setCheckedCreatedRestrictions(true)
                setOpenModalConfig(false)
                setMessageSuccess(isUpdate ? 'Restrições editadas com sucesso' : 'Restrições criadas com sucesso')
                setOpenMessage(true)
                setCompleteRestrictions(true)
                // if (openModalConfig) {
                //     window.location.reload(false);
                // }
            }

        } catch (error) {
            setLoading(false)
            handleMessageError(error)
        }
    }

    const createdAndUpdatedBankOfHours = async () => {
        try {
            if (!employeeId && !openModalConfig) {
                setMessageError('Cadastre os dados pessoais do colaborador para continuar!')
                setOpenMessageError(true)
                return;
            }
            setLoading(true)
            const dt = {
                "bankHoursEmployeeId": bankOfHoursData.bankHoursEmployeeId,
                "dtFrom": bankOfHoursData.dtFrom,
                "dtTo": bankOfHoursData.dtTo,
                "initialValue": timeToMinutes(bankOfHoursData.initialValue),
                "cumulativeHoursLimit": bankOfHoursData.extraHoursLimit,
                "employeeId": employeeId,
                "delete": !bankOfHoursData.isBankOfHours
            }

            const dts = {
                "employees": employeeIds,
                "bankHours": {
                    "initialValue": timeToMinutes(bankOfHoursData.initialValue),
                    "dtFrom": bankOfHoursData.dtFrom,
                    "dtTo": bankOfHoursData.dtTo,
                    "disableCurrent": false,
                    "cumulativeHoursLimit": bankOfHoursData.extraHoursLimit
                }
            }
            const sendCreatedBankOfHours = await instance.post(openModalConfig ? '/settings/employees/register/lot' : '/bankHours',
                openModalConfig ? dts : dt, {
                headers: {
                    'Authorization': `Bearer ${decodedToken}`
                }
            })

            if (sendCreatedBankOfHours.status == 200) {
                // setEmployeeId(sendCreatedBankOfHours.data.employeeId)
                getListEmployees()
                setLoading(false)
                handleExpandClick('bankOfHours')
                setCheckedCreatedBankOfHours(true)
                setOpenModalConfig(false)
                setMessageSuccess(isUpdate ? 'Banco de horas editadas com sucesso' : 'Banco de horas criado com sucesso')
                setOpenMessage(true)
                setCompleteBankOfHours(true)
                if (openModalConfig) {
                    window.location.reload(false);
                }
                setOpenRestrictions(true)
            }
        } catch (error) {
            console.log(error)
            setLoading(false)
            handleMessageError(error)
        }
    }


    const createdEmployee = async () => {
        try {
            setLoading(true)

            const dt = {
                "name": dataInformation.name,
                "cpf": dataInformation.cpf?.replace(/\D/g, ''),
                "phone": dataInformation.phone?.replace(/\D/g, ''),
                "postalCode": dataInformation.cep,
                "address": dataInformation.address,
                "dtBirthday": dataInformation.dateOfBird,
                "employeeId": row.id ? row.id : null
            }
            if (dt.name && dt.cpf && dt.phone) {
                const sendCreatedEmployee = await instance.post('/employeee', dt, {
                    headers: {
                        'Authorization': `Bearer ${decodedToken}`
                    }
                })
                if (sendCreatedEmployee.status == 200) {
                    setEmployeeId(sendCreatedEmployee.data.employeeId)
                    getListEmployees()
                    setLoading(false)
                    handleExpandClick('dataPerson')
                    setCheckedCreatedEmployee(true)
                    setMessageSuccess(isUpdate ? 'Colaborador editado com sucesso' : 'Colaborador criado com sucesso')
                    setOpenMessage(true)
                    setCompleteEmployee(true)
                    setOpenOffice(true)
                }
            } else {
                handleMessageError("Revise todos os dados obrigatórios!")
                setLoading(false)
            }
        } catch (error) {
            handleMessageError(error)
            setLoading(false)
        }
    }

    const handleMessageError = (error) => {
        try {
            console.log(error)
            setMessageError(error)
            setOpenMessageError(true)
        } catch (error) {
            console.log(error)
            setMessageError(error)
            setOpenMessageError(true)
        }
    }

    const createdOfficeAndDepartment = async () => {
        try {
            if (!employeeId) {
                setMessageError('Cadastre os dados pessoais do colaborador para continuar!')
                setOpenMessageError(true)
                return;
            }
            setLoading(true)
            const dt = {
                "officeId": officeAndDepartmentInfo.officeId,
                "departmentId": officeAndDepartmentInfo.departmentId,
                "admission": officeAndDepartmentInfo.admission,
                "workplace": dataCity,
                "employeeId": employeeId,
                "pisCode": officeAndDepartmentInfo.pisCode,
                "enrollment": officeAndDepartmentInfo.enrollment
            }
            const sendOfficeEmployee = await instance.post('/employeee/updateInfo', dt, {
                headers: {
                    'Authorization': `Bearer ${decodedToken}`
                }
            })

            if (sendOfficeEmployee.status == 200) {
                getListEmployees()
                setLoading(false)
                handleExpandClick('office')
                setCheckedCreatedOffice(true)
                setMessageSuccess(isUpdate ? 'Cargo e Departamento editado com sucesso' : 'Cargo e Departamento criado com sucesso')
                setOpenMessage(true)
                setAutocompleteVisible(false)
                setCompleteOffice(true)
                setOpenSchedule(true)
            }

        } catch (error) {
            handleMessageError(error)
            setLoading(false)
        }
    }

    const createWorkingDay = async () => {
        try {
            if (!openModalConfig && !employeeId) {
                setMessageError('Cadastre os dados pessoais do colaborador para continuar!');
                setOpenMessageError(true);
                return;
            }

            setLoading(true)
            const isSchedule = dataWorkingDay.find(schedule => schedule.workingDay.description == scheduleView.find(schedule => schedule.value == selectedSchedule).dataSchedule.workingDay.description)
            let id = isSchedule ? isSchedule.workingDay.id : scheduleView.find(schedule => schedule.value == selectedSchedule).dataSchedule.workingDay.id
            if (selectedModelSchedule == 'model' && !isSchedule) {
                let dt = scheduleView.find(schedule => schedule.value == selectedSchedule).dataSchedule
                if (dt.workingDay.description == 'Escala 6x1') {
                    dt.shifts[0].days = []
                }

                const sendWorkingDay = await instance.post('/workingDay', dt, {
                    headers: {
                        'Authorization': `Bearer ${decodedToken}`
                    }
                })
                id = sendWorkingDay.data[0].workingDayId
            }
            const dt = {
                "employee":
                {
                    "name": dataInformation.name ? dataInformation.name : "",
                    "phone": dataInformation.phone ? dataInformation.phone : "",
                    "enrollment": officeAndDepartmentInfo.enrollment ? officeAndDepartmentInfo.enrollment : "",
                    "departmentId": officeAndDepartmentInfo.departmentId ? officeAndDepartmentInfo.departmentId : "",
                    "officeId": officeAndDepartmentInfo.officeId ? officeAndDepartmentInfo.officeId : "",
                    "cpf": dataInformation.cpf ? dataInformation.cpf : "",
                    "postalCode": dataInformation.cep ? dataInformation.cep : "",
                    "pisCode": officeAndDepartmentInfo.pisCode ? officeAndDepartmentInfo.pisCode : '',
                    "address": dataInformation.address ? dataInformation.address : "",
                    "admission": officeAndDepartmentInfo.admission ? officeAndDepartmentInfo.admission : "",
                    "emailContact": "",
                    // "workplace": officeAndDepartmentInfo.workplace ? officeAndDepartmentInfo.workplace : {},
                    "workplace": {},
                    "id": employeeId
                }, "workSchedule": {
                    "dtRef": initialDateSchedule ? initialDateSchedule : new Date().toISOString().split('T')[0],
                    "workScale": id
                }
            }

            const dts = {
                "employees": employeeIds,
                "workSchedule": {
                    "dtRef": initialDateSchedule ? initialDateSchedule : new Date().toISOString().split('T')[0],
                    "workScale": id
                }
            }
            const sendWorkingDayLot = await instance.post('/settings/employees/register/lot', openModalConfig ? dts : dt, {
                headers: {
                    'Authorization': `Bearer ${decodedToken}`
                }
            })
            if (sendWorkingDayLot.status == 200) {
                setLoading(false)
                handleExpandClick('schedule')
                setCheckedCreatedSchedule(true)
                setOpenModalConfig(false)
                setMessageSuccess(isUpdate ? 'Jornada editada com sucesso' : 'Jornada criada com sucesso')
                setOpenMessage(true)
                setCompleteSchedule(true)
                if (openModalConfig) {
                    window.location.reload(false);
                }
                setOpenBankHours(true)
            }
        } catch (error) {
            handleMessageError(error)
            setLoading(false)
        }
    }

    const creatOffice = async () => {

        try {

            const sendOfficeEmployee = await instance.post('/office', { "name": nameNewOffice }, {
                headers: {
                    'Authorization': `Bearer ${decodedToken}`
                }
            })
            if (sendOfficeEmployee.status == 200) {
                await getListOffice()
                let newOffice = { ...officeAndDepartmentInfo }
                newOffice['officeId'] = sendOfficeEmployee.data.id
                setOfficeAndDepartmentInfo(newOffice)
                setCreatedOffice(sendOfficeEmployee.data)
                const newDataOffice = officeList.find(office => office.name == nameNewOffice)
                setOffice(sendOfficeEmployee.data)
                setNameNewOffice('')
                setOpenModalOffice(false)


            }
        } catch (error) {
            console.log(error)
            handleMessageError(error)
        }
    }

    const creatDepartment = async () => {

        try {

            const sendDepartmentEmployee = await instance.post('/department', { "name": nameNewOffice }, {
                headers: {
                    'Authorization': `Bearer ${decodedToken}`
                }
            })
            if (sendDepartmentEmployee.status == 200) {
                await getListDepartment()
                let newDepartment = { ...officeAndDepartmentInfo }
                newDepartment['departmentId'] = sendDepartmentEmployee.data.id
                setOfficeAndDepartmentInfo(newDepartment)
                setCreatedDepartment(sendDepartmentEmployee.data)
                setDepartment(sendDepartmentEmployee.data)
                setNameNewOffice('')
                setOpenModalOffice(false)


            }
        } catch (error) {
            console.log(error)
            handleMessageError(error)
        }
    }



    const getListEmployees = async () => {
        try {
            const result = await instance.get('/employee/list')
            const data = result.data.sort((a, b) => a.name.localeCompare(b.name));
            setEmployeeData(data)
        } catch (error) {
            console.log('funcionarios: ' + error)
            handleMessageError(error)
        }
    }

    const getLocations = async () => {
        try {
            const result = await instance.get('/location')
            // const data = result.data.sort((a, b) => a.name.localeCompare(b.name));
            const nameLocation = []
            setLocations(result.data)
            result.data.map(location => nameLocation.push({ value: location.description, displayValue: location.description, id: location.id }))
            setLocationName(nameLocation)

        } catch (error) {
            console.log('local: ' + error)
            handleMessageError(error)
        }
    }


    const getDisabledEmployees = async () => {
        try {
            const result = await instance.get('/employee/inactive')
            const data = result.data.sort((a, b) => a.name.localeCompare(b.name));
            setDisabledEmployee(data)
        } catch (error) {
            console.log('funcionarios: ' + error)
            handleMessageError(error)
        }
    }

    const getListDepartment = async () => {
        try {
            const result = await instance.get('/department')
            const data = result.data.sort((a, b) => a.name.localeCompare(b.name));
            data.unshift({ id: 'addDepartment', name: 'Cadastrar um novo departamento' })
            setDepartmentList(data)
        } catch (error) {
            console.log('departamento :' + error)
            handleMessageError(error)
        }
    }

    const getListOffice = async () => {
        try {
            const result = await instance.get('/office')
            const data = result.data.sort((a, b) => a.name.localeCompare(b.name));
            data.unshift({ id: 'addOffice', name: 'Cadastrar um novo cargo' })
            setOfficeList(data)
        } catch (error) {
            console.log('departamento :' + error)
            handleMessageError(error)
        }
    }

    const getListSchedule = async () => {
        try {
            const result = await instance.get('/workingDay')
            let schedulesName = []
            const data = result.data.forEach(element => {
                schedulesName.push(element.workingDay.description)
            });
            setSchedule(schedulesName)
            setDataWorkingDay(result.data)
        } catch (error) {
            console.log('departamento :' + error)
            handleMessageError(error)
        }
    }


    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    }

    const handleSelectedCard = (event, type) => {
        try {
            handleChangePage(null, 0)
            setSelectedEmployee('')
            setSelectedDepartment('departamento')
            setScheduleSelected('escala')
            if (type == 'search') {
                setIsFilter(false);
                setStatus('status')
                return;
            }
            filterByStatus(event)
        } catch (error) {
            console.log(error)
        }
    }

    const handleSelectedEmployee = (event) => {
        try {
            handleChangePage(null, 0)
            if (event == 'todos') {
                setSelectedEmployee('')
                setSelectedDepartment('departamento')
                setScheduleSelected('escala')
                setEmployeeFilterSelected(employeeNewData);
                return;
            }
            setIsFilter(true);
            setSelectedEmployee(event)
            const employeeData = employeeNewData.find(employee => capitalizeFirstLetter(employee.name) == event)
            setSelectedDepartment(employeeData.department)
            setScheduleSelected(employeeData._workingDay)
            setEmployeeFilterSelected([employeeData])
        } catch (error) {
            console.log(error)
        }
    }

    const filterByDepartment = (event) => {
        try {
            handleChangePage(null, 0)
            setSelectedDepartment(event.target.value);
            setIsFilter(true);
            setSelectedEmployee('')
            let filterDepartment = event.target.value == 'departamento' ? employeeNewData : employeeNewData.filter(employee => employee.department == event.target.value);
            if (scheduleSelected != 'escala') {
                filterDepartment = filterDepartment.filter(employee => employee._workingDay == scheduleSelected);
            }
            if (status != 'status') {
                let active = []
                let gestor = []
                let disabled = []
                if (status == 'ativos') {
                    active = filterDepartment.filter(employee => employee.admission == undefined && employee.isManager == false);
                }
                if (status == 'gestor') {
                    gestor = filterDepartment.filter(employee => employee.admission == undefined && employee.isManager == true);
                }
                if (status == 'desligados') {
                    disabled = filterDepartment.filter(employee => employee.admission != undefined);
                }
                filterDepartment = [...active, ...gestor, ...disabled];
            }
            setEmployeeFilterSelected(filterDepartment);
        } catch (error) {
            console.log(error)
        }
    }

    const filterBySchedule = (event) => {
        try {
            handleChangePage(null, 0)
            setIsFilter(true);
            setScheduleSelected(event.target.value);
            setSelectedEmployee('')
            let filterSchedule = event.target.value == 'escala' ? employeeNewData : employeeNewData.filter(employee => employee._workingDay == event.target.value);
            if (selectedDepartment != 'departamento') {
                filterSchedule = filterSchedule.filter(employee => employee.department == selectedDepartment);
            }
            if (status != 'status') {
                let active = []
                let gestor = []
                let disabled = []
                if (status == 'ativos') {
                    active = filterSchedule.filter(employee => employee.admission == undefined && employee.isManager == false);
                }
                if (status == 'gestor') {
                    gestor = filterSchedule.filter(employee => employee.admission == undefined && employee.isManager == true);
                }
                if (status == 'pendentes') {
                    disabled = filterSchedule.filter(employee => employee.admission != undefined);
                }
                filterSchedule = [...active, ...gestor, ...disabled];
            }
            if (event.target.value == 'notSchedule') {
                filterSchedule = employeeNewData.filter(employee => !employee._workingDay)
            }
            setEmployeeFilterSelected(filterSchedule);
        } catch (error) {
            console.log(error)
        }
    }

    const filterByStatus = (event) => {
        try {
            handleChangePage(null, 0)
            setIsFilter(true);
            setStatus(event.target.value)
            setSelectedEmployee('')
            let filterStatus = event.target.value == 'status' ? employeeNewData : []
            if (event.target.value == 'ativos') {
                filterStatus = employeeNewData.filter(employee => employee.isManager == false && employee.admission == undefined && employee.userId != null);
            }
            if (event.target.value == 'gestores' || event.target.value == 'gestor') {
                filterStatus = employeeNewData.filter(employee => employee.isManager == true && employee.admission == undefined);
            }
            if (event.target.value == 'pendentes') {
                filterStatus = employeeNewData.filter(employee => employee.userId == null && employee.admission == undefined);
            }
            if (event.target.value == 'desligados') {
                filterStatus = employeeNewData.filter(employee => employee.admission != undefined);
            }
            if (selectedDepartment != 'departamento') {
                filterStatus = filterStatus.filter(employee => employee.department == selectedDepartment);
            }
            if (scheduleSelected != 'escala') {
                filterStatus = filterStatus.filter(employee => employee._workingDay == scheduleSelected);
            }
            setEmployeeFilterSelected(filterStatus)
        } catch (error) {
            console.log(error)
        }
    }





    const handlechangeFilter = (event, type) => {
        try {
            if (type == 'department') {
                filterByDepartment(event);
            }
            if (type == 'schedule') {
                filterBySchedule(event);
            }
            if (type == 'status') {
                filterByStatus(event);
            }
        } catch (error) {
            console.log(error);
        }
    }



    const dataCard = [
        {
            number: employeeData.filter(employee => employee.isManager == false && employee.admission == undefined && employee.userId != null).length,
            type: 'Ativos',
            color: '#5aca5e',
            value: 'ativos',
            title: 'ativos'
        },
        {
            number: employeeData.filter(employee => employee.userId == null && employee.admission == undefined).length,
            type: 'Pendentes',
            color: '#ff9801',
            value: 'pendentes',
            title: 'que não acessaram'
        },
        {
            number: manager.length,
            type: 'Gestores',
            color: '#484fdb',
            value: 'gestores',
            title: 'Gestores'
        }
    ]

    function capitalizeFirstLetter(string) {
        try {
            if (string) {
                return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
            }
        } catch (error) {
            console.log(error)
        }
    }

    function limitarString(s, limite) {
        if (s.length > limite) {
            return s.substring(0, limite) + "...";
        } else {
            return s;
        }
    }

    const openMenuCheckedEmployee = (event) => {
        setAnchorElEmployeeList(event.currentTarget)
    }

    const handleCloseMenuChecked = () => {
        setAnchorElEmployeeList(null)
    }

    const handleCloseMenu = () => {
        setAnchorEl(null);
        setIsUpdate(false)
        setAutocompleteVisible(false)
        setDataInformation({
            name: '',
            cpf: '',
            phone: '',
            dateOfBirth: '',
            cep: '',
            address: ''
        })
        setScheduleNew(modelsSchedules)
        setSelectedModelSchedule('model')
        setSelectedSchedule('scheduleNorm')
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSelectAllClick = (event) => {

        if (event.target.checked) {
            const newSelecteds = employee.map((n) => n.name);
            setSelected(newSelecteds);
            const ids = []
            employee.map(employee => ids.push(employee.id))
            setEmployeeIds([...ids]);
            return;
        }
        setSelected([]);
        setEmployeeIds([])
    };

    const handleSelectOneClick = (event, name, row) => {
        try {
            const selectedIndex = selected.indexOf(name);
            let newSelected = [];

            if (selectedIndex === -1) {
                newSelected = newSelected.concat(selected, name);
            } else if (selectedIndex === 0) {
                newSelected = newSelected.concat(selected.slice(1));
            } else if (selectedIndex === selected.length - 1) {
                newSelected = newSelected.concat(selected.slice(0, -1));
            } else if (selectedIndex > 0) {
                newSelected = newSelected.concat(
                    selected.slice(0, selectedIndex),
                    selected.slice(selectedIndex + 1),
                );
            }
            const id = employee.find(employee => employee.name === name).id;
            if (event.target.checked) {
                setEmployeeIds(prevIds => [...prevIds, id]);
            } else {
                setEmployeeIds(prevIds => prevIds.filter(employeeId => employeeId !== id));
            }

            setSelected(newSelected);
        } catch (error) {
            console.log(error)
        }

    };


    const handleClickOpenModalInformation = (row) => {
        setOpenModalInformation(true);
        setInformationEmployee(row)
    };

    const handleCloseModalInformation = () => {
        setOpenModalInformation(false);
    };

    const handleOpenModalConfig = (type) => {
        if (selected.length == 0) {
            setMessageErrorConfig('Selecione pelo menos 1 colaborador')
            setOpenMessageErrorConfig(true)
            return;
        }
        setOpenModalConfig(true)
        setTypeModalConfig(type)
        getRestrictionsAndLocationEmployee(null)
        getDays(null, null, selectedSchedule)
    }

    const handleCloseModalConfig = () => {
        setOpenModalConfig(false)
    }


    let modalInformation = {
        openModalInformation,
        handleClickOpenModalInformation,
        handleCloseModalInformation,
        informationEmployee,
        capitalizeFirstLetter
    }

    let tableState = {
        employee,
        selected,
        page,
        rowsPerPage,
        numSelected,
        rowCount,
        handleSelectOneClick,
        handleSelectAllClick,
        handleChangeRowsPerPage,
        handleChangePage,
        capitalizeFirstLetter,
        limitarString,
        handleClickOpenModalInformation,
        handleCloseMenu,
        handleClickMenu,
        row,
        anchorEl,
        lastWorkingDay,
        demissionDate,
        handleChangeDemission,
        demissionEmployee,
        confirmDemission,
        setConfirmDemission,
        setOpenModalDemission,
        openModalDemission,
        handleClickDemission,
        reactivateEmployee,
        removeGestor,
        openMenuCheckedEmployee,
        anchorElEmployeeList,
        handleCloseMenuChecked
    };

    const viewEmployeeRegistration = {
        viewRegistration,
        handleCloseViewRegistration,
        handleViewRegistration,
        handleViewRegistrationReset,
        handleSummaryDataPerson,
        textRestrictions,
        textBankOfHours,
        textSchedule,
        textDataOffice,
        textDataPerson,
        openRestrictions,
        openBankHours,
        openSchedule,
        openOffice,
        openDataPerson,
        row,
        isUpdate,
        handleClickDiscard,
        dataInformation,
        handleChangeInformationForm,
        atualizationButton,
        departmentList,
        officeList,
        handleInputChangeCity,
        optionsCity,
        handleChangeOfficeAndDepartment,
        department,
        office,
        createdEmployee,
        loading,
        handleExpandClick,
        expanded,
        openMessage,
        setOpenMessage,
        saveHeader,
        handleCloseModalOffice,
        openModalOffice,
        employeeId,
        officeAndDepartmentInfo,
        createdOfficeAndDepartment,
        createdOffice,
        creatOffice,
        nameNewOffice,
        setNameNewOffice,
        creatDepartment,
        restrictions,
        handleChangeBankOfHours,
        bankOfHoursData,
        createdAndUpdatedBankOfHours,
        handleChangeRestrictions,
        createdAndUpdateRestrictions,
        modelsSchedules,
        optionsModel,
        selectedModelSchedule,
        handleChangeTypeSchedule,
        selectedSchedule,
        handleChangeModelSchedule,
        horary,
        updatedHoursSchedule,
        handleClickUpdateSchedule,
        handleChangeHorary,
        scheduleView,
        formatShiftTime,
        workHours,
        days,
        getDays,
        createWorkingDay,
        messageSuccess,
        openModalImport,
        handleCloseModalImport,
        handleImportEmployee,
        sheetDownload,
        sendImportEmployee,
        message,
        copyToClipboard,
        openMessageError,
        setOpenMessageError,
        messageError,
        disabledBankHours,
        locations,
        locationName,
        selectedLocation,
        handleInputChangeLocation,
        listBlockedDevice,
        selectedBloqueDevice,
        handleInputChangeBloquedDevice,
        selectedCity,
        checkedCreatedEmployee,
        checkedCreatedOffice,
        checkedCreatedSchedule,
        checkedCreatedBankOfHours,
        checkedCreatedRestrictions,
        handleTextFieldClick,
        isAutocompleteVisible,
        setSelectedCity,
        completeEmployee,
        completeOffice,
        completeSchedule,
        completeBankOfHours,
        completeRestrictions,
        groupShiftsByTime,
        setinitialDateSchedule,
        initialDateSchedule,
        setMessageError,
        bankOfHoursData,
        setDisabledBankHours
    }


    return {
        employeeNewData,
        departmentList,
        dataCard,
        companyName,
        handlechangeFilter,
        selectedDepartment,
        employeeFilterSelected,
        schedule,
        scheduleSelected,
        isFilter,
        status,
        selectedEmployee,
        handleSelectedEmployee,
        tableState,
        modalInformation,
        handleSelectedCard,
        viewEmployeeRegistration,
        handleOpenModalConfig,
        typeModalConfig,
        openModalConfig,
        handleCloseModalConfig,
        messageErrorConfig,
        openMessageErrorConfig,
        setOpenMessageErrorConfig,
        loadingEmployee
    }
}

export default EmployeeData;